// SARKY: two small, PDP-scoped behaviors for the native sticky-add-to-cart
// bar's .sticky-add-to-cart__variant text -- neither touches variant
// resolution, availability, or cart submission (assets/variant-picker.js
// and assets/sticky-add-to-cart.js stay completely unmodified).
//
// 1. Tapping the "Select Size" prompt (rendered by
//    sections/product-information.liquid when current_variant is blank)
//    scrolls the real Size fieldset in the native variant-picker into view,
//    instead of the old custom sticky bar's own combined variant dropdown.
//    Delegated on document so it also covers the prompt re-created by (2)
//    below, without a second listener.
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  if (!event.target.closest('.sarky-sticky-select-size')) return;

  const sizeFieldset =
    Array.from(document.querySelectorAll('.sarky-variant-picker fieldset')).find(
      (fieldset) => !fieldset.classList.contains('variant-option--swatches')
    ) || document.querySelector('.sarky-variant-picker');

  sizeFieldset?.scrollIntoView({ behavior: 'smooth', block: 'center' });
});

// 2. assets/sticky-add-to-cart.js's own #handleVariantUnavailable() is only
//    reached when the currently checked options don't resolve to any real
//    Shopify variant at all; its native fallback there writes the raw
//    checked option values straight into .sticky-add-to-cart__variant via
//    textContent (e.g. "White"), joined with " / " for multiple values --
//    exactly the combined variant-title text format Billy asked to remove.
//    'variant:update' bubbles (assets/events.js), and the native handler
//    listens on the closest .shopify-section -- document is a further
//    ancestor, so this listener always runs strictly after the native one
//    finishes, in the same synchronous bubble pass. When the event's own
//    variant resource is null (the only case that fallback text applies),
//    this replaces whatever text was just written with the same clean
//    "Select Size" prompt the initial Liquid render uses.
document.addEventListener('variant:update', (event) => {
  if (event.detail.resource) return;

  const productId = event.detail.data && event.detail.data.productId;
  const stickyBar = productId
    ? document.querySelector(`sticky-add-to-cart[data-product-id="${productId}"]`)
    : null;
  const variantTextEl = stickyBar && stickyBar.querySelector('.sticky-add-to-cart__variant');
  if (!variantTextEl) return;

  variantTextEl.textContent = '';
  const prompt = document.createElement('button');
  prompt.type = 'button';
  prompt.className = 'sarky-sticky-select-size';
  prompt.textContent = 'Select Size';
  variantTextEl.appendChild(prompt);
});
